module.exports = __webpack_public_path__ + "static/media/black-identify-pan-icon.2841f6e6.svg";